import { render, staticRenderFns } from "./confirmYuesaoWorkers.vue?vue&type=template&id=0af825d0&scoped=true&"
import script from "./confirmYuesaoWorkers.vue?vue&type=script&lang=js&"
export * from "./confirmYuesaoWorkers.vue?vue&type=script&lang=js&"
import style0 from "./confirmYuesaoWorkers.vue?vue&type=style&index=0&id=0af825d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af825d0",
  null
  
)

export default component.exports